import { NavLink } from "react-router-dom";

const items = [
  { to: "/staff", end: true, label: "Home", icon: "⌂" },
  { to: "/staff/shifts", label: "Shifts", icon: "◷" },
  { to: "/staff/work", label: "Work", icon: "✓" },
  { to: "/staff/me", label: "Me", icon: "◎" },
];

export function StaffBottomNav() {
  return (
    <nav className="staff-bottom-nav" aria-label="Staff navigation">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) => `staff-bottom-nav__item${isActive ? " staff-bottom-nav__item--active" : ""}`}
        >
          <span className="staff-bottom-nav__icon" aria-hidden="true">{item.icon}</span>
          <span className="staff-bottom-nav__label">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
